module.exports = __webpack_public_path__ + "static/media/G.99da604a.png";